import { render, staticRenderFns } from "./section-list.vue?vue&type=template&id=15d0b6ac&scoped=true"
import script from "./section-list.vue?vue&type=script&lang=js"
export * from "./section-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d0b6ac",
  null
  
)

export default component.exports